import CompanyPrescreeningSettings from "./CompanyPrescreeningSettings";

export default CompanyPrescreeningSettings;
